import { t } from 'i18next';
import { setUser } from '../../redux/slices/user';
import { store } from '../../redux/store';
import { authenticate, setCredentials } from '../../services/auth/auth.service';
import { LOGON_METHOD } from '../entities/sys-constants';
import { default as ILogin, default as IUser } from '../entities/user';

const NativeLogin = async (login: string, password: string, error_email: any, handleClose: any) => {
    try {
        const loginUser: ILogin = {
            userName: 'UserName',
            email: login,
            logonMethod: LOGON_METHOD.NATIVE,
            password: password,
            accountType: AccountType.USER
        };

        const res = await authenticate(loginUser);

        if (res.status === 'Failed') {
            if (res.message.indexOf('exists already') > -1) {
                error_email(`${t('login_page.alreadyExistUser')} ${loginUser.email}`);
            } else {
                error_email(res.message);
            }
        } else {
            const authResponse = res.payload;
            setCredentials({
                accessToken: authResponse.accessToken,
                refreshToken: authResponse.refreshToken
            });

            const appUser: IUser = {
                ...res.payload,
                logonMethod: LOGON_METHOD.NATIVE,
                accessToken: authResponse.accessToken,
                refreshToken: authResponse.refreshToken,
                userId: '0',
                accountType: res.payload.accountType || AccountType.USER
            };

            store.dispatch(setUser(appUser));
            handleClose();
        }

        return loginUser.logonMethod;
    } catch {}
};

export default NativeLogin;

enum AccountType {
    USER = 0,
    ADMIN = 1
}

export { AccountType };
